<template lang="pug">
table.holdings.mobile_table.table.is-striped.is-narrow.is-fullwidth.is-hoverable
  thead
    tr
      th.logo.has-text-centered
      th.name
        slot(name="search")
      //- th.nowrap.is-narrow Symbol
      th.is-narrow Country
      th.is-narrow Sector
      th.has-text-right.is-narrow Percentage
      th.has-text-right.is-narrow You own
  tbody
    tr(v-for='(stock, index) in holdings')
      template(v-if="index == 4")
        //- td(colspan='7')
        //-   .columns
        //-     .column
        //-     .column.is-narrow: honeymoney_block
        //-     .column
      template(v-else)
        td.logo.has-text-centered
          img(v-if='logos[stock.name] && logos[stock.name].logo', :src="logos[stock.name].logo")
          span.nologo(v-else style='color: lightgrey;') ?
        td(data-label='Name')
          span(v-if='logos[stock.name] && logos[stock.name].domain')
            a(:href="'http://' + logos[stock.name].domain" target='_blank', v-html='highlight(stock.name)')
          span(v-else, v-html='highlight(stock.name)') 11
        //- td.symbol(data-label='Symbol')
        //-   a(:href="'https://finance.yahoo.com/q?s=' + stock.name" target='_blank' v-html='highlight(stock.symbol)')
        td.nowrap(data-label='Country') {{ stock.country }}
        td.nowrap(data-label='Sector') {{ stock.sector }}
        td.has-text-right(data-label='Percentage')
          .nowrap(v-for='(percentage, fund) in stock.percentage_in_funds')
            span {{ percentage | to_percentage }}
            //- em  {{ fund }}
        td.has-text-right(data-label='You own')
          .nowrap(v-for='(owned, fund) in stock.owned_in_funds')
            span {{ owned | currency }}
            //- em  {{ fund }}
</template>


<script>
export default {
  name: 'holdings_table',
  props: ['holdings', 'search_term'],
  components: {
    honeymoney_block: require('./../components/honeymoney_block.vue').default
  },
  data() {
    return {
      logos: {}
    }
  },
  mounted() {
    this.fetchLogos()
  },
  methods: {
    fetchLogos() {
      axios.get('/funds/logos.json').then((response) => { this.logos = response.data })
    },
    highlight(name) {
      this.search_term = this.search_term.trim()
      if (this.search_term.length == 0) return name
      name = name.replace(this.search_term, `<b class='highlighted'>${this.search_term}</b>`)
      name = name.replace(_.capitalize(this.search_term), `<b class='highlighted'>${_.capitalize(this.search_term)}</b>`)
      return `${name}`
    }
  }
}
</script>

<style lang="sass">
.holdings
  input
    width: 200px
    margin-left: 1em
  td, th
    vertical-align: middle
  th.name
    line-height: 36px
  td.logo, th.logo
    height: 85px
    width: 100px
    img
      max-height: 64px
      border: 1px solid lightgrey
      border-radius: 5px
      padding: 3px
    .nologo
      font-size: 30px
  .highlighted
    background-color: yellow
  td em
    font-style: normal
    opacity: 0.7
    font-size: 0.8rem
</style>
